import React, { useState } from "react";

import StepOne from "./step-one/StepOne";
import StepTwo from "./step-two/StepTwo";
import StepThree from "./step-three/StepThree";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { Card } from "antd";

import { addCourse } from "../../../api";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

import MainLoaderCourse from "../../../commonFunctions/loaders/MainLoader/MainLoaderCourse";

// =======================|| COURSE STEPS ||======================= //

const steps = ["Basic Details", "Keywords Tags", "Course Image"];

const AddCourses = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  // Course data
  const [course_title, setcourse_title] = useState("");
  const [course_category, setcourse_category] = useState("");
  const [course_keywords, setcourse_keywords] = useState([]);
  const [course_image, setcourse_image] = useState("");

  // Loading state
  const [loading, setloading] = useState(false);

  // =======================|| STEP HELPERS ||======================= //

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  // =======================|| NEXT ||======================= //

  const handleNext = () => {
    let newSkipped = skipped;

    // Step 1 - Basic Details
    if (activeStep === 0) {
      if (course_title === "") {
        Swal.fire({
          title: "Empty Field!",
          text: "Please Fill Course Title!",
          icon: "error",
        });

        return;
      }

      if (course_category === "") {
        Swal.fire({
          title: "Empty Field!",
          text: "Please Select a Course Category!",
          icon: "error",
        });

        return;
      }
    }

    // Step 2 - Keywords
    if (activeStep === 1) {
      if (course_keywords.length < 5) {
        Swal.fire({
          title: "Keywords Error!",
          text: "Please enter a minimum of 5 Keywords!",
          icon: "error",
        });

        return;
      }
    }

    // Step 3 - Course Image
    if (activeStep === 2) {
      if (course_image === "") {
        Swal.fire({
          title: "Image Error!",
          text: "Please Upload an Image!",
          icon: "error",
        });

        return;
      }
    }

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  // =======================|| BACK ||======================= //

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // =======================|| SUBMIT COURSE ||======================= //

  const handleSubmit = (e) => {
    e.preventDefault();

    // Final image validation
    if (course_image === "") {
      Swal.fire({
        title: "Image Error!",
        text: "Please Upload an Image!",
        icon: "error",
      });

      return;
    }

    setloading(true);

    addCourse(
      course_title,
      course_category,
      course_keywords,
      course_image,
      setloading
    );
  };

  // =======================|| UI ||======================= //

  return (
    <div className="all-courses-container">
      {loading && <MainLoaderCourse />}

      <Card bordered={false}>
        <Box sx={{ width: "100%" }}>
          {/* Stepper */}
          <Stepper className="my-2" activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};

              if (index === 0) {
                labelProps.optional = (
                  <Typography variant="caption">
                    Step One
                  </Typography>
                );
              }

              if (index === 1) {
                labelProps.optional = (
                  <Typography variant="caption">
                    Step Two
                  </Typography>
                );
              }

              if (index === 2) {
                labelProps.optional = (
                  <Typography variant="caption">
                    Step Three
                  </Typography>
                );
              }

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>

          {/* Step Content */}
          <div className="my-5">
            {activeStep === 0 && (
              <StepOne
                setcourse_category={setcourse_category}
                setcourse_title={setcourse_title}
              />
            )}

            {activeStep === 1 && (
              <StepTwo
                course_keywords={course_keywords}
                setcourse_keywords={setcourse_keywords}
              />
            )}

            {activeStep === 2 && (
              <StepThree
                setcourse_image={setcourse_image}
              />
            )}
          </div>

          {/* Navigation */}
          <div className="row col-12">
            <div className="col-6">
              <Button
                variant="contained"
                className="mt-5"
                color="primary"
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Back
              </Button>
            </div>

            <div className="col-6 text-end p-0">
              {activeStep === steps.length - 1 ? (
                <Button
                  className="mt-5"
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                >
                  Send For Approval
                </Button>
              ) : (
                <Button
                  className="mt-5"
                  onClick={handleNext}
                  variant="contained"
                  color="primary"
                >
                  Next
                </Button>
              )}
            </div>
          </div>
        </Box>
      </Card>
    </div>
  );
};

export default AddCourses;

